import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';

export class CustomHamburgerFooter extends BaseComponent<React.Props<CustomHamburgerFooter>, {}> {
    public render(): React.ReactElement<React.Props<CustomHamburgerFooter>> {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <a
                    href="https://www.bpro-solutions.com/de/service/impressum.cfm"
                    target="_blank"
                    className="copyright-text"
                >
                    {t('Imprint')}/{t('Data privacy')}
                </a>
            );
        }
        return (
            <div className="core-footer">
                <div className="core-footer-group">
                    <a href="https://www.bpro-solutions.com/de/service/impressum.cfm" target="_blank">{t('Imprint')}/{t('Data privacy')}</a>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/CustomHamburgerFooter.tsx